<template>
  <b-navbar toggleable="lg">
    <b-container>
      <ChoiboiLogo />

      <b-navbar-toggle target="main-header-menu"></b-navbar-toggle>
      <b-collapse id="main-header-menu" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item
            v-for="navItem in filterNavUrls"
            :key="navItem.text"
            :href="navItem.url"
            :target="navItem.isTargetBlank ? '_blank' : ''"
            :disabled="navItem.url === window.location.pathname ? true : false"
          >
            {{ navItem.text }}
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
import ChoiboiLogo from './ChoiboiLogo';
import navUrls from '../assets/data/nav-urls.json';

export default {
  name: 'SiteHeader',
  components: {
    ChoiboiLogo
  },
  computed: {
    filterNavUrls() {
      return this.navUrls.filter(url => url.displayInHeader);
    }
  },
  data() {
    return {
      navUrls
    };
  }
};
</script>

<style lang="scss" scoped>
nav {
  background-color: #fff;
  box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.1);

  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;

  a {
    font-weight: bold;

    &:hover, &:focus {
      color: $darkGrey !important;
    }
  }

  .logo {
    color: $primaryGreen;
    font-weight: bold;
    font-size: 20px;
    padding: 5px 0;
  }
}
</style>
